<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-on="$listeners" />
  <svg v-else :class="svgClass" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
  /**
   * svg 图标使用说明
   *
   * 1，下载svg文件
   * 2，给文件命名放到assets/icon/svg文件夹下
   * 3，该组件已经全局注册，可以直接使用
   * <svg-icon icon-class="thumbs-up" class-name="thumbs-up"/>
   *
   * 属性说明：
   * icon-class：图标名称（svg的文件名）
   * class-name：图标的class
   */
  export default {
    name: 'SvgIcon',
    props: {
      iconClass: {
        type: String,
        required: true,
        default: ''
      },
      className: {
        type: String,
        default: ''
      }
    },
    computed: {
      isExternal() {
        return /^(https?:|mailto:|tel:)/.test(this.iconClass)
      },
      iconName() {
        return `#icon-${this.iconClass}`
      },
      svgClass() {
        if (this.className) {
          return 'svg-icon ' + this.className
        } else {
          return 'svg-icon'
        }
      },
      styleExternalIcon() {
        return {
          mask: `url(${this.iconClass}) no-repeat 50% 50%`,
          '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`
        }
      }
    }
  }
</script>

<style scoped>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .svg-external-icon {
    background-color: currentColor;
    mask-size: cover!important;
    display: inline-block;
  }
</style>